import Api from "@/services/api";

const basic = "client";
export default {
  get() {
    return Api.default().get("/" + basic + "?limit=100");
  },
  getOne(id) {
    return Api.default().get("/" + basic + "/" + id);
  },
  put(id, param) {
    return Api.default().put("/" + basic + "/" + id, param);
  },
  post(param) {
    return Api.default().post("/" + basic, param);
  },
  delete(id) {
    return Api.default().delete("/" + basic + "/" + id);
  },
  postCard(id, param) {
    return Api.default().post("/" + basic + "/creditcard/" + id, param);
  },
};
